<template>
  <div class="return-receiving">
    <el-scrollbar ref="scroller" class="return-receiving-scroller">
      <dialog-table ref="dialog" :table-select="$tableSelect" :data="data" />
    </el-scrollbar>
  </div>
</template>

<script>
import DialogTable from '@utils/table-select/components/dialog-table'
import TableSelect from '@utils/table-select'
import Table from '@utils/table'
import Search from '@utils/search'
import Select from './groupSelect.vue'

const table = new Table('commonDialog')
  .sortable(false)
  .singleSelect(true)
  .add('itemNo')
  .add('itemName')
  .add('itemSpec')
  .add('groupNo')
  .add('groupName')
  .add('unitNo').name('unitName')

const search = new Search('commonDialog')
  .placeholder('placeHolder1')
  .add('itemName').col(12)
  .add('groupNos').component(Select).attrs({ 'multiple': true }).col(12)
  .add('purchaseUnitNos').label('purchaseUnitName').select('/purchaseUnit/getPurchaseUnitPage').attrs({ 'multiple': true }).col(12) // .listeners({ 'input': getValue, 'created-options': getValue })

const $tableSelect = new TableSelect()
  .type('page')
  .url('/bmItem/getBmItemPage', process.env.VUE_APP_BASE_DATA_API)
  .dialogTable(table)
  .search(search)
  .params(vm => {
    return { purchaseUnitNo: vm.data.purchaseUnitNo || vm.data.purchaseOrgNo || vm.data.purchaseNo, orgNo: vm.data.purchaseUnitNo || vm.data.purchaseOrgNo }
  })

export default {
  components: {
    DialogTable
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selection: []
    }
  },
  computed: {
    $tableSelect() {
      return $tableSelect
    }
  },
  mounted() {
    this.$refs.dialog.open()
  },
  methods: {
    validate() {
      this.selection = this.$refs.dialog.selection
      if (!this.selection.length) {
        this.$message.warning(this.$t('common.needSelection') || '')
      }
      return this.selection.length
    }
  }
}
</script>

<style lang="scss" scoped>
.return-receiving {
  margin: 0 -15px;
}
</style>
